import { Helmet } from "react-helmet-async";

// Tietosuojalausunnon SEO- ja meta-tiedot
function PrivacyPolicyHelmetComponent() {
  return (
    <Helmet>
      {/* Sivun otsikko */}
      <title>
        Tietosuojalausunto & GDPR | Spiderlegs Productions
      </title>

      {/* Meta-kuvaus */}
      <meta
        name="description"
        content="Spiderlegs Productionsin tietosuojalausunto. Lue, miten käsittelemme henkilötietoja GDPR:n mukaisesti laitevuokrauksen, varausten ja yhteydenottojen yhteydessä."
      />

      {/* Avainsanat (ei kriittinen, mutta ok) */}
      <meta
        name="keywords"
        content="tietosuojalausunto, tietosuoja, GDPR, henkilötiedot, laitevuokraus, varaus, Spiderlegs Productions"
      />

      {/* Sivuston kirjoittaja */}
      <meta name="author" content="Arttu Stenius" />

      {/* Hakukoneet: sallitaan indeksointi */}
      <meta name="robots" content="index, follow" />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="Tietosuojalausunto | Spiderlegs Productions"
      />
      <meta
        property="og:description"
        content="Tutustu Spiderlegs Productionsin tietosuojakäytäntöihin ja siihen, miten henkilötietoja käsitellään turvallisesti ja GDPR:n mukaisesti."
      />
      <meta
        property="og:image"
        content="https://spiderlegsproductions.com/assets/new_logo.webp"
      />
      <meta
        property="og:url"
        content="https://spiderlegsproductions.com/tietosuojalausunto"
      />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Tietosuojalausunto | Spiderlegs Productions"
      />
      <meta
        name="twitter:description"
        content="Lue, miten Spiderlegs Productions käsittelee henkilötietoja turvallisesti ja GDPR:n mukaisesti."
      />
      <meta
        name="twitter:image"
        content="https://spiderlegsproductions.com/assets/new_logo.webp"
      />
    </Helmet>
  );
}

export default PrivacyPolicyHelmetComponent;
